import React, { useCallback, useEffect, useState } from 'react';
// import { useTranslation } from "react-i18next";
import { Row, Col } from 'react-bootstrap';
import { motion } from "framer-motion";
import "./index.scss";

import NoDataFound from "../../../../../components/ui/NoDataFound";
import SkeletonLoader from "../../../../../components/ui/SkeletonLoader";

import { useScanInfoContext } from "../../../../ScanInfo/ScanInfoContext";

import { useSelector, useDispatch } from 'react-redux';
import { getTopVulnerableSubdomain, getTopVulnerableIpaddress } from "../../../../../store/actions/dashboardAction";

import { formatNumber } from "../../../../../utils/util";

const TopVulnerabilities = () => {

    const vulnerableSubdomainResponse = useSelector((state) => state.dashboard.vulnerableSubdomain)
    const vulnerableIpaddressResponse = useSelector((state) => state.dashboard.vulnerableIpaddress)

    const dispatch = useDispatch();

    const {
        domainId,
        scanId,
        organizationId,
        triggerStatsFetch,
        setTriggerStatsFetch,
    } = useScanInfoContext();

    const [subDomainLoading, setSubDomainLoading] = useState(false);
    const [ipAddressLoading, setIpAddressLoading] = useState(false);

    const fetchVulnerableSubdomain = useCallback(()=>{
        setSubDomainLoading(true);
        setIpAddressLoading(true);
        const params = organizationId.toLowerCase() !== "all" && domainId.toLowerCase() === "all" ? `&organization_id=${organizationId}`: `&domain=${domainId}&scan_id=${scanId}`
        dispatch(getTopVulnerableSubdomain(params))       
        dispatch(getTopVulnerableIpaddress(params))       
    },[organizationId, domainId, scanId, dispatch])

    useEffect(() => {
        if (triggerStatsFetch) {
            fetchVulnerableSubdomain()
            setTriggerStatsFetch(false);
        }
    }, [triggerStatsFetch, setTriggerStatsFetch, fetchVulnerableSubdomain]);

    useEffect(()=>{
        if(vulnerableSubdomainResponse !== null) {
            setSubDomainLoading(false)
        }
    },[vulnerableSubdomainResponse])

    useEffect(()=>{
        if(vulnerableIpaddressResponse !== null) {
            setIpAddressLoading(false)
        }
    },[vulnerableIpaddressResponse])

    return (
        <div className="mt-4">            
            <Row className="mt-4">
                <Col lg={6}>
                    {
                        subDomainLoading ?
                        <SkeletonLoader type={"line"} count={5} />
                        :
                        <motion.div
                            className="h-100"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.4 }}
                        >
                            <div className="bg-white-with-shadow p-4 h-100">
                                <div className="d-flex justify-content-between dashboard-box-container">
                                    <p className="heading font-bold">Top Vulnerable Subdomains</p>
                                </div>
                                <div className="vulnerable-list-container">
                                    {
                                        vulnerableSubdomainResponse?.stats?.subdomain?.length > 0 &&
                                        vulnerableSubdomainResponse?.stats?.subdomain?.map((data, index)=>{
                                            return (
                                                <div className="dashboard-type-container rounded p-3 mt-3" key={index}>
                                                    <div className="align-items-center">
                                                        <Row className="justify-content-between">
                                                            <Col lg={1}>
                                                                <p className="number-count mb-0">{index+1}</p>
                                                            </Col>
                                                            <Col lg={8}>
                                                                <div className="count-top h-100 d-flex align-items-center">
                                                                    <p className="sens mb-0 mt-1 ms-3">{data?.name}</p>
                                                                    {/* <p className="cred mb-0 ms-3">Credential disclosure check</p> */}
                                                                </div>
                                                            </Col>
                                                            <Col lg={3}>
                                                                <div className="count-top d-flex justify-content-end gap-3 mt-2">
                                                                    {/* <p className="active mb-0">Potential</p> */}
                                                                    <p className="count-cred mb-0">Count:&nbsp;<span className='font-bold'>{formatNumber(data?.count)}</span></p>
                                                                    {/* <p className="mt-1 mb-0">
                                                                        <img src={send} alt="send" />
                                                                    </p> */}
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }                        
                                    {
                                        vulnerableSubdomainResponse?.stats?.subdomain?.length === 0 &&
                                        <NoDataFound />
                                    }
                                    {
                                        (vulnerableSubdomainResponse?.status === "failed" || vulnerableSubdomainResponse === "Not Found") &&
                                        <NoDataFound noDataText={vulnerableSubdomainResponse?.description} />
                                    }
                                </div>
                            </div>
                        </motion.div>
                    }                    
                </Col>
                <Col lg={6}>
                    {
                        ipAddressLoading ?
                        <SkeletonLoader type={"line"} count={5} />
                        :
                        <motion.div
                            className="h-100"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.4 }}
                        >
                            <div className="bg-white-with-shadow p-4 h-100">
                                <div className="d-flex justify-content-between mb-2 dashboard-box-container">
                                    <p className="heading font-bold">Top Vulnerable IP Addresses</p>
                                    {/* <p className="view-all"><img src={move} alt="search" className="position-absolute search-icon" /></p> */}
                                </div>
                                <div className="vulnerable-list-container">
                                    {
                                        vulnerableIpaddressResponse?.stats?.ip_address?.length > 0 &&
                                        vulnerableIpaddressResponse?.stats?.ip_address.map((data, index) => {
                                            return (
                                                <div className="dashboard-type-container rounded p-3 mt-3" key={index}>
                                                    <div className="align-items-center">
                                                        <Row className="justify-content-between">
                                                            <Col lg={1}>
                                                                <p className="number-count mb-0">{index+1}</p>
                                                            </Col>
                                                            <Col lg={8}>
                                                                <div className="count-top d-flex align-items-center h-100">
                                                                    <p className="sens mb-0 mt-1 ms-3">{data?.name}</p>
                                                                    {/* <p className="blacklisted mb-0 ms-3">Malware</p> */}
                                                                </div>
                                                            </Col>
                                                            <Col lg={3}>
                                                                <div className="count-top d-flex justify-content-end gap-3 mt-2">
                                                                    {/* <p className="comp mb-0">Compromised</p> */}
                                                                    <p className="count-cred mb-0">Count:&nbsp;<span className='font-bold'>{formatNumber(data?.count)}</span></p>
                                                                    {/* <p className="mt-1 mb-0">
                                                                        <img src={send} alt="send" />
                                                                    </p> */}
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                    {
                                        vulnerableIpaddressResponse?.stats?.ip_address?.length === 0 &&
                                        <NoDataFound />
                                    }
                                    {
                                        (vulnerableIpaddressResponse?.status === "failed" || vulnerableSubdomainResponse === "Not Found") &&
                                        <NoDataFound noDataText={vulnerableIpaddressResponse?.description} />
                                    }
                                </div>
                            </div>
                        </motion.div>
                    }                    
                </Col>
            </Row>
        </div>

    )
}


export default TopVulnerabilities;